import React, { useState, useEffect, useRef, ReactElement } from 'react'
import { Image, } from 'antd'
// import { CloseCircleOutlined, } from '@ant-design/icons'
import Draggable from 'react-draggable'
import QuestionComp from '@/pages/rag/components/question'
import RobotImg from '@/assets/images/robot.png'
import PromptBoxImg from '@/assets/images/OIP-C.png'

// eslint-disable-next-line no-unused-vars
function Rag (props: { autoPopRag: boolean, openQuestion: (params: any) => void }): ReactElement {
    const { autoPopRag, openQuestion } = props
    const [winH, setWinH] = useState(0)
    const [, setHover] = useState(false)
    const [, setPopOpen] = useState(false)
    const [detailPopOpen, setDetailPopOpen] = useState(false)
    const [close, setClose] = useState('')
    const [showPrompt, setShowPrompt] = useState(false)
    const [promptClass, setPromptClass] = useState('')
    const [word, setWord] = useState('。')
    const si = useRef<any>()

    // const { TextArea } = Input

    const clickQuestion = () => {
        setDetailPopOpen(true)
        setPopOpen(false)
        setClose('close reverse_close')
        // 等待转动动画
        setTimeout(() => {
            setHover(false)
        }, 300)
    }
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const changeShowPrompt = () => {
        setPromptClass('')
        clearInterval(si.current)
        // 等待动态完成
        setTimeout(() => {
            setShowPrompt(false)
        }, 500)
    }
    useEffect(() => {
        openQuestion(clickQuestion)
        setTimeout(() => {
            setPromptClass('prompt_open')
        }, 100)
        let i = 0
        si.current = setInterval(() => {
            i++
            if (i === 1) {
                setWord('。')
            } else if (i === 2) {
                setWord('。。')
            } else if (i === 3) {
                setWord('。。。')
                i = 0
            }
        }, 500)
        const offsetH = 0
        setWinH(document.body.clientHeight - offsetH)
        const onResize = () => {
            setWinH(document.body.clientHeight - offsetH)
        }
        window.addEventListener('resize', onResize)
        return () => {
            window.removeEventListener('resize', onResize)
        }
    }, [])
    useEffect(() => {
        if (close.includes('reverse_close')) {
            setPopOpen(false)
        }
    }, [close])
    useEffect(() => {
        if (autoPopRag) {
            clickQuestion()
        }
    }, [autoPopRag])
    useEffect(() => {
        if (detailPopOpen) {
            document.body.classList.add('overflow_hidden')
        } else {
            document.body.classList.remove('overflow_hidden')
        }
    }, [detailPopOpen])

    return (<>
        <Draggable>
            {/* <Popover title={false}
                visible={popOpen}
                content={<QAComp winH={winH} width={400} 
                    clickQuestion={clickQuestion}
                />}
                placement="topRight"
                onVisibleChange={(open: boolean) => {
                    if (open) {
                        document.body.classList.add('overflow_hidden')
                    } else {
                        setClose('close reverse_close')
                        // 等待转动动画
                        setTimeout(() => {
                            setHover(false)
                        }, 300)
                        document.body.classList.remove('overflow_hidden')
                    }
                }}
            > */}
            <div className='rag_button_box hand'
                // onMouseEnter={() => {
                //     setHover(true)
                //     // setPopOpen(true)
                //     setClose('close')
                // }}
                // onMouseOut={() => {
                //     setClose('close reverse_close')
                //     // 等待转动动画
                //     setTimeout(() => {
                //         setHover(false)
                //     }, 300)
                // }}
            >
                <div style={{ position: 'relative', width: 200 }}>
                    {showPrompt && <div className={`prompt_box ${promptClass}`}>
                        {/* <CloseCircleOutlined style={{ position: 'absolute', right: 10, zIndex: 3, fontSize: 20 }}
                            onClick={changeShowPrompt}
                        /> */}
                        <Image src={PromptBoxImg} preview={false} onClick={clickQuestion} />
                        <div className='prompt_text'
                            onClick={clickQuestion}
                        >嗨，探索技术解决方案的新方式！让我成为您的助手，迅速找到您所需的技术方案{word}</div>
                    </div>}
                    <Image src={RobotImg} preview={false} className='search_icon hand' onClick={clickQuestion}
                        onMouseOver={() => setShowPrompt(true)}
                        onMouseOut={() => setShowPrompt(false)}
                    />
                </div>
                {/* {!hover ? <div className='rag_button'>
                    <SearchOutlined style={{ color: '#036fc0' }} />
                </div> : <div className={`rag_button ${close}`}>
                    <CloseOutlined style={{ color: '#036fc0' }} />
                </div>} */}
            </div>
            {/* </Popover> */}
        </Draggable>
        <QuestionComp
            winH={winH}
            isModalOpen={detailPopOpen}
            setIsModalOpen={setDetailPopOpen}
        />
    </>)
}

export default Rag